import { v4 as uuid } from 'uuid';

import {
  FieldBlueprint,
  FieldGroupBlueprint,
  SectionBlueprint,
  SubsectionBlueprint,
  FieldTypes,
} from '@zinnia/form-engine-sdk';

export function switchToCustomPartName<T extends { partName: string; isCustom?: boolean; id: string }>(
  blueprint: T,
): T {
  return { ...blueprint, partName: `custom-${uuid()}`, id: uuid(), isCustom: true };
}

export function toCustomField(blueprint: FieldBlueprint): FieldBlueprint {
  if (blueprint.fieldType === FieldTypes.autocomplete) {
    const originalPartName = blueprint.partName;
    const customClonedBlueprint = switchToCustomPartName(blueprint);

    if (customClonedBlueprint.addressAutocompleteFields.streetAddress === originalPartName) {
      customClonedBlueprint.addressAutocompleteFields.streetAddress = customClonedBlueprint.partName;
    }

    return customClonedBlueprint;
  }

  return switchToCustomPartName(blueprint);
}

export function toCustomFieldGroup(blueprint: FieldGroupBlueprint): FieldGroupBlueprint {
  const customClonedBlueprint = switchToCustomPartName(blueprint);

  customClonedBlueprint.fields = customClonedBlueprint.fields.map(toCustomField);

  return customClonedBlueprint;
}

export function toCustomSubsection(blueprint: SubsectionBlueprint): SubsectionBlueprint {
  const customClonedBlueprint = switchToCustomPartName(blueprint);

  customClonedBlueprint.fieldGroups = customClonedBlueprint.fieldGroups.map(toCustomFieldGroup);

  return customClonedBlueprint;
}

export function toCustomSection(blueprint: SectionBlueprint): SectionBlueprint {
  const customClonedBlueprint = switchToCustomPartName(blueprint);

  customClonedBlueprint.subsections = customClonedBlueprint.subsections.map(toCustomSubsection);

  return customClonedBlueprint;
}
